import {AnswerSortEnum, AnswersStatus, LangEnum} from '@enums';
import {AnswerQueryInterface} from "../api/interfaces";
import {Pagination} from "@components/Pages/AnswersPage/constants";

export const statusFiltersOptions = Object.values(AnswersStatus);

export const notAppliedAnswersFilters: AnswerQueryInterface = {
  offset: 0,
  limit: Pagination.ANSWERS_ON_PAGE_COUNT_FIRST,
  status: [],
  lang: LangEnum.ALL,
  order: [AnswerSortEnum.createdAt_DESC],
};
